import axios from 'axios';

export const API_HOST = process.env.NODE_ENV === 'production' ? 'https://api.rebel-tool.org' : 'http://localhost:8888';

const instance = axios.create({
  baseURL: `${API_HOST}/api`,
  headers: { 'Content-Type': 'application/json' },
});
export default instance;
